"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from "react";
import { Carousel } from "@/components/ui/carousel";
import AutoScroll from "embla-carousel-auto-scroll";
export function AutoCarousel(t0) {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [AutoScroll({
      speed: 0.08
    })];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props) {
    t2 = <Carousel plugins={t1} {...props}>{children}</Carousel>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}